
import store from "@/store";
import {computed, onMounted, ref, toRefs, watch} from "vue";
import RewardListSingle from "@/components/member/reward/RewardListSingle.vue";
import SvgIcon from "@/components/common/SvgIcon.vue";
import router from "@/router";
import MemberHeader from "@/components/member/MemberHeader.vue";
import Filtering from "@/components/common/Filtering.vue";
import Search from "@/components/common/Search.vue";
import i18n from "@/locales";
import {useI18n} from "vue-i18n";

const Isotope: any = require('isotope-layout');

export default {
  name: "Reward",
  displayName: "List",
  components: {Search, Filtering, MemberHeader, SvgIcon, RewardListSingle},
  props: {
    category: {
      type: String,
      required: true
    }
  },
  setup(props: any) {
    const {category} = toRefs(props);
    const {t} = useI18n();
    const type = computed(() => store.state.selectedType);
    const list = computed(() => {
      const memberData = store.state.memberData[type.value];
      // const memberData = sampleMemberData[type.value];
      if (memberData) {
        switch (category.value?.toLowerCase()) {
          case "reward":
            return memberData.rewards;
          case "privilege":
            return memberData.privileges;
          case "offer":
            return memberData.bDayOffer;
          case "event":
            return memberData.happenings;
          default:
            return [];
        }
      } else {
        return [];
      }
    });

    const onBackClicked = () => {
      router.push({
        name: 'Member',
        params: {
          lang: i18n.global.locale
        }
      });
    }

    const gridRef = ref<HTMLElement>();
    const gridJs = ref<typeof Isotope>();
    // const isInitialized = ref(false);
    onMounted(() => {
      // if (!list.value || list.value?.length === 0 || isInitialized.value) return;
      if (gridRef.value) {
        // console.log("init", list.value?.length === 0, isInitialized.value)
        gridJs.value = new Isotope(gridRef.value, {
          itemSelector: '.grid-item',
          getSortData: {
            name: '.rls-name',
            point: '.rls-point-redeem parseInt',
          },
          sortBy: ['name', 'point'],
        });
        // isInitialized.value = true;
      }
    });

    watch(list, (val) => {
      if (val && val?.length > 0) {
        gridJs.value?.reloadItems();
        gridJs.value?.arrange();
        console.log(gridJs.value);
      }
    }, {
      deep: true
    });

    const filterOption = [t('show-all')];
    const filterClass = ['*'];
    const filterIndex = ref(-1);
    // const sortOption = ['A-Z', 'Z-A'];
    // console.log(category.value);
    if (category.value === 'reward') {
      filterOption.push(t('gift'), t('voucher'));
      filterClass.push(':not(.rls-coupon)', '.rls-coupon');
      // sortOption.push('VIC Points: Low to High', 'VIC Points: High to Low')
    } else {
      filterOption.push(t('dining'), t('shopping'));
      filterClass.push('.dining', '.shopping');
    }
    // const sortIndex = ref(0);
    watch(filterIndex, (val) => {
      // console.log("filter", val, gridJs.value);
      gridJs.value?.arrange({
        filter: filterClass[val]
      })
    });

    const searchKey = ref('');
    watch(searchKey, (val) => {
      console.log(val);
      gridJs.value?.arrange({
        filter: (item: HTMLElement) => {
          return item.querySelector('.rls-name')?.innerHTML.toLowerCase().includes(val.toLowerCase());
        }
      })
    })

    return {
      gridRef,
      list,
      onBackClicked,
      filterOption,
      filterIndex,
      // sortOption,
      // sortIndex,
      searchKey,
    }
  }
}
